import DefaultAttributeDropdown from './DefaultAttributeDropdown';

export default DefaultAttributeDropdown;
